import CwPdfPreview from "./index.vue"

export default CwPdfPreview